import { Directionality } from "@angular/cdk/bidi";
import { ChangeDetectorRef, ContentChildren, Directive, EventEmitter, Inject, Input, Optional, Output, QueryList, inject } from "@angular/core";
import { InputBoolean } from "ng-zorro-antd/core/util";
import { NzMenuDirective } from "ng-zorro-antd/menu";
import { UiMenuItemComponent } from "./components/menu-item/menu-item.component";
import { UiSubmenuComponent } from "./components/submenu/submenu-component";
import { UiMenuModeType, UiMenuThemeType } from "./menu.models";
import { UiMenuService } from "./services/menu.service";
import { UiIsMenuInsideDropDownToken, UiMenuServiceLocalToken } from "./utils/menu.utils";

function MenuServiceFactory(): UiMenuService {
  const serviceInsideDropDown = inject(UiMenuService, { skipSelf: true, optional: true });
  const serviceOutsideDropDown = inject(UiMenuServiceLocalToken);
  return serviceInsideDropDown ?? serviceOutsideDropDown;
}

function MenuDropDownTokenFactory(): boolean {
  const isMenuInsideDropDownToken = inject(UiIsMenuInsideDropDownToken, { skipSelf: true, optional: true });
  return isMenuInsideDropDownToken ?? false;
}

@Directive({
  selector: "[ui-menu]",
  exportAs: "uiMenu",
  providers: [
    {
      provide: UiMenuServiceLocalToken,
      useClass: UiMenuService,
    },
    /** use the top level service **/
    {
      provide: UiMenuService,
      useFactory: MenuServiceFactory,
    },
    /** check if menu inside dropdown-menu component **/
    {
      provide: UiIsMenuInsideDropDownToken,
      useFactory: MenuDropDownTokenFactory,
    },
  ],
  standalone: true,
})
export class UiMenuDirective extends NzMenuDirective {
  @Input("uiInlineIndent") public nzInlineIndent = 24;
  @Input("uiTheme") public nzTheme: UiMenuThemeType = "light";
  @Input("uiMode") public nzMode: UiMenuModeType = "vertical";
  @Input("uiInlineCollapsed") @InputBoolean() public nzInlineCollapsed = false;
  @Input("uiSelectable") @InputBoolean() public nzSelectable = !this.isMenuInsideDropDown;
  @Output("uiClick") public readonly nzClick = new EventEmitter<UiMenuItemComponent>();
  @ContentChildren(UiMenuItemComponent, { descendants: true })
  public listOfNzMenuItemDirective!: QueryList<UiMenuItemComponent>;
  @ContentChildren(UiSubmenuComponent, { descendants: true })
  public listOfNzSubMenuComponent!: QueryList<UiSubmenuComponent>;

  constructor(
    uiMenuService: UiMenuService,
    @Inject(UiIsMenuInsideDropDownToken) public isMenuInsideDropDown: boolean,
    cdr: ChangeDetectorRef,
    @Optional() directionality: Directionality
  ) {
    super(uiMenuService, isMenuInsideDropDown, cdr, directionality);
  }
}
